<template>
    <div>
        <div class="modal-backdrop show"></div>
        <div class="modal d-block" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('add_product_condition') }}</h5>
                        <button type="button" class="close" @click="$emit('close')">
                        <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label for="country" class="required">Product type</label>
                        <app-input 
                            :placeholder = "$t('select_producttype_phd')" 
                            type = "advance-search-select"
                            fetch-url = "/product_type/serverside/selectable-name"
                            listValueField = "name"
                            v-model = "condition" 
                            :loaded-per-time = "5" 
                            :required = "true"  
                        />
                        <br>
                        <label for="code" class="required">Doc control</label>
                        <app-input
                            type="search-select" 
                            v-model="doc_control" 
                            :required="true" 
                            :list="list" 
                            :placeholder="$t('select_doc_control')"
                        />
                        <br>
                        <label for="name" class="required">Description</label>
                        <app-input  type="text-editor" v-model="description" :minimal="true" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            Close
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-primary" @click="submit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "AddProductCondittion",
    data() {
        return {
            condition: "",
            doc_control : "",
            description : "",
            list : [
                {id : 1, value : "PO"}, 
                {id : 2, value : "SO"}
            ],
        };
    },
    methods: {
        submit() {
            this.$emit("save", this.condition, this.doc_control, this.description);
        },
    },
};
</script>
  